import React, { useEffect } from "react";

import { Navigate, useRouteError, isRouteErrorResponse } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { logChatError } from "@/taskpane/services/chat";

export default function ErrorPage() {
  let error = useRouteError() as Error;
  const queryClient = useQueryClient();

  console.error(error);

  // Report chat render crashes to the backend: until now they only reached the console
  // before the redirect below, so a chat that "closed by itself" left no trace.
  // No session id: the log Lambda answers 404 but writes the request body to CloudWatch first.
  useEffect(() => {
    const match = window.location.hash.match(/^#\/folder\/([^/]+)\/([^/?]+)\/chat/);
    const crpcen = queryClient.getQueryData<{ crpcen?: string | null } | null>(["getUserAttributes"])?.crpcen;
    if (!match || !crpcen) return;
    logChatError({
      client_id: crpcen,
      dossier_id: match[1],
      sous_dossier_id: match[2],
      error_details: {
        message: error?.message ?? String(error),
        stack: error?.stack,
        context: JSON.stringify({
          source: "route_error_page",
          userAgent: navigator.userAgent,
          // Parameter names only: values can hold tokens
          urlParams: [...new URLSearchParams(window.location.search).keys()],
          // Set on <html> by Google Translate while a page is translated
          translated: document.documentElement.className.includes("translated-"),
        }),
      },
    });
  }, []);

  return <Navigate to={window.location.hash === "#/folders" ? `${window.location.origin}${window.location.pathname}?${window.location.search}#/login` : `${window.location.origin}${window.location.pathname}?${window.location.search}#/folders`} replace={true} />
}
